import { Group, Switch, Title } from "@mantine/core"
import type { PropsWithChildren } from "react"
import { useTranslation } from "react-i18next"
import { SearchInput } from "../forms"

interface IProps {
  title?: string
  onSearch?: (search: string) => void
  onHidden?: (hidden: boolean) => void
}

export function SessionsTitle({ title, onSearch, onHidden, children }: PropsWithChildren<IProps>) {
  const { t } = useTranslation()
  return (
    <Group>
      <Title order={2} mr="auto">
        {title}
      </Title>
      {children}
      {onHidden && <Switch label={t("Show hidden")} onChange={(e) => onHidden(e.currentTarget.checked)} />}
      {onSearch && <SearchInput onChange={onSearch} />}
    </Group>
  )
}
